import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { Service } from './pages';

export const ServiceEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Service',
      element: <Service />,
      path: '/',
      index: true,
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return <Fragment key="routes">{routes}</Fragment>;
};
